import React, { FunctionComponent } from 'react';
import { cn } from '@/utils/cn';

interface Props {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  withMaxWidth?: boolean;
}

/**
 * Celular: las superficies (tarjetas, tablas, buscadores, listas, botones a todo el ancho)
 * van a 10 px del borde (`px-2.5`). Los textos que encabezan (título, descripción, migas,
 * pestañas, nombres de categoría) llevan 6 px más (16 px del borde) con esta clase, como en
 * la propuesta aprobada. Desde `sm` no cambia nada.
 */
export const MOBILE_TEXT_INSET = 'max-sm:mx-1.5';

export const ResponsiveContainer: FunctionComponent<Props> = (props) => {
  return (
    <div className={cn('px-2.5 sm:px-6 lg:px-8 relative', props.className)} style={props.style}>
      <div className="m-auto max-w-screen-2xl">{props.children}</div>
    </div>
  );
};
